import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import { RouteImage } from '../../../../../assets/routeImage'
import { disableStyleButtonMui } from '../../../../../utils/disableStyleButton'
import { useDispatch, useSelector } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import * as styled from '../../../style/main.style'
import Header from '../../../Header'
import Navbar from '../../../Navbar'
import TableCustom from '../../../../../component/table/tableCustom'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import HeaderTopicTable from '../../../../../component/header-table/HeaderTopicTable'
import Loading from '../../../../../component/loading/Loading'
import AddTypes from './add-type/AddTypes'

// STORE
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'

// API
import { TypesApi, getType, updateType } from '../../../../../api/type/type.api';
import FilterSelect from '../../../../../component/select/filterSelect'
import ModalCustom from '../../../../../component/modal/ModalCustom'
import EditType from './edit-type/EditType'

const ProjectTypeSetting: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const navigate: NavigateFunction = useNavigate();
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const permission = useSelector((state: any) => state?.permission?.permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [types, setTypes] = useState<any[]>([]);
    const [showModalAdd, setShowModalAdd] = useState<boolean>(false);
    const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
    const [idType, setIdType] = useState<number>(Number);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const handleToggleAddModal = () => setShowModalAdd(!showModalAdd)
    const handleToggleEditModal = () => setShowModalEdit(!showModalEdit)

    const handleChangeStatus = async (idType: number, typeStatus: string, obj: any) => {
        dispatch(setLoading())
        let condition: updateType = {
            isActivities: obj?.isActivities === 1 ? true : false,
            typeStatus: typeStatus,
            typeNo: obj?.typeNo,
            typeName: obj?.typeName,
            idFiscalYear: obj?.idFiscalYear,
            isEquipment: obj?.isEquipment,
            detailProjectStatus: undefined
        }
        await TypesApi.updateType(idType, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetType())
    }
    const handleChangeIsActivity = async (idType: number, activity: boolean, obj: any) => {
        dispatch(setLoading())
        let condition: updateType = {
            isActivities: activity,
            typeStatus: obj?.status,
            typeNo: obj?.typeNo,
            typeName: obj?.typeName,
            idFiscalYear: obj?.idFiscalYear,
            isEquipment: obj?.isEquipment,
            detailProjectStatus: undefined
        }
        // console.log(condition)
        await TypesApi.updateType(idType, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetType())
    }
    const handleChangeIsEquipment = async (idType: number, isEquipment: boolean, obj: any) => {
        dispatch(setLoading())
        let condition: updateType = {
            isActivities: obj?.isActivities,
            typeStatus: obj?.typeStatus,
            typeNo: obj?.typeNo,
            typeName: obj?.typeName,
            idFiscalYear: obj?.idFiscalYear,
            isEquipment: isEquipment,
            detailProjectStatus: undefined
        }
        // console.log(condition)
        await TypesApi.updateType(idType, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetType())
    }


    const handleGetType = useCallback(async () => {
        dispatch(setLoading())
        let condition: getType = {
            page: page,
            limit: pageLimit
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        await TypesApi.getType(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setTotalItems(res.data?.result?.meta?.totalItems)
                    setTypes(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit])



    const headCells = [
        {
            id: "typeNo", disablePadding: false, width: 210, align: 'center', label: "รหัสประเภทโครงการ"
        },
        {
            id: "typeName", disablePadding: true, width: 350, align: 'center', label: "ประเภทโครงการ"
        },
        {
            id: "SUB", width: 190, disablePadding: true, align: 'center', label:"กิจกรรมย่อย"
        },
        {
            id: "IS_EQ", width: 190, disablePadding: true, align: 'center', label:"รายงานครุภัณฑ์"
        },
        {
            id: "STATUS", width: 190, disablePadding: true, align: 'center', label:"สถานะการใช้งาน"
        },
        {
            id: "EDIT", disablePadding: false, width: 100, align: "left", class: true, label: ""
        }
    ];


    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idType, isActivities, isEquipment, typeName, typeNo, typeStatus } =
            objData;

        const objRenderData = {
            key: no,
            id: idType,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: typeNo },
                { option: "TEXT", align: "left", label: typeName },
                {
                    option: "TEXT", align: "center", label:
                        <div className='max-w-[5rem] m-auto'>
                            <FilterSelect
                                disabled={permission?.find((list: any) => list?.code === "ProjectType.Edit")?.permit === false}
                                headingNormal
                                renderValue={() =>
                                    <ListItemText className='relative'>
                                        {isActivities ? (
                                            <Typography
                                                className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                                {t("มี")}
                                            </Typography>
                                        ) : (
                                            <Typography
                                                className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                                {t("ไม่มี")}
                                            </Typography>
                                        )}
                                    </ListItemText>
                                }
                                label={t('STATUS.LABEL')}
                                selectId="select-plan"
                                value={isActivities}
                                labelId="label-plan"
                                onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeIsActivity(idType, e.target.value === t("STATUS.ACTIVE") ? true : false, objData)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <Typography className='text-light_success'><li>{t("มี")}</li></Typography>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <Typography className='text-danger'><li>{t("ไม่มี")}</li></Typography>
                                    </MenuItem>
                                ]}
                            />
                        </div>
                },
                {
                    option: "TEXT", align: "center", width: 50, label:
                        <div className='max-w-[5rem] m-auto'>
                            <FilterSelect
                                disabled={permission?.find((list: any) => list?.code === "ProjectType.Edit")?.permit === false}
                                headingNormal
                                renderValue={() =>
                                    <ListItemText className='relative'>
                                        {isEquipment ? (
                                            <Typography
                                                className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                                {t("มี")}
                                            </Typography>
                                        ) : (
                                            <Typography
                                                className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                                {t("ไม่มี")}
                                            </Typography>
                                        )}
                                    </ListItemText>
                                }
                                label={t('STATUS.LABEL')}
                                selectId="select-plan"
                                value={isEquipment}
                                labelId="label-plan"
                                onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeIsEquipment(idType, e.target.value === t("STATUS.ACTIVE") ? true : false, objData)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <Typography className='text-light_success'><li>{t("มี")}</li></Typography>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <Typography className='text-danger'><li>{t("ไม่มี")}</li></Typography>
                                    </MenuItem>
                                ]}
                            />
                        </div>

                },
                {
                    option: "TEXT", align: "center", label:
                        <FilterSelect
                            disabled={permission?.find((list: any) => list?.code === "ProjectType.Edit")?.permit === false}
                            headingNormal
                            renderValue={() =>
                                <ListItemText className='relative'>
                                    {typeStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }
                            label={t('STATUS.LABEL')}
                            selectId="select-plan"
                            value={typeStatus}
                            labelId="label-plan"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatus(idType, e.target.value, objData)}
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />

                },
                {
                    option: "COMPONENT",
                    align: "center",
                    width: 100,
                    class: true,
                    component:
                        <>
                            {permission?.find((list: any) => list?.code === "ProjectType.Edit")?.permit === true && (
                                <div className='w-full flex justify-center gap-5'>
                                    <Button
                                        onClick={() => {
                                            setIdType(idType)
                                            handleToggleEditModal()
                                        }}
                                        startIcon={<img src={RouteImage.editPen} />}
                                        sx={disableStyleButtonMui}>{"แก้ไข"}</Button>
                                </div>
                            )}
                        </>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    useEffect(() => {
        const permissionCheck = permission?.find((list: any) => list?.code === "ProjectType.Read")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])

    useEffect(() => {
        handleGetType();
    }, [handleGetType])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            {showModalAdd &&
                <ModalCustom
                    componentHeight='600px'
                    maxWidth='1000px'
                    enableExit={handleToggleAddModal}
                    alignHeader='center'
                    maxHeight='auto'
                    heading='เพิ่มประเภทโครงการ'
                    component={<AddTypes fetchData={handleGetType} toggleModal={handleToggleAddModal} />}
                />}
            {showModalEdit && (
                <ModalCustom
                    componentHeight='600px'
                    maxWidth='1000px'
                    enableExit={handleToggleEditModal}
                    alignHeader='center'
                    maxHeight='auto'
                    heading='แก้ไขประเภทโครงการ'
                    component={<EditType idType={idType} fetchData={handleGetType} toggleModal={handleToggleEditModal} />}
                />
            )}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <div>
                            <Typography className='text-primary' variant='h4'>
                                {`ปีงบประมาณ ${idFiscalYear === 0 ? '' : idFiscalYear} / ประเภทโครงการ`}
                            </Typography>
                        </div>
                        <span>
                            {permission?.find((list: any) => list?.code === "ProjectType.Create")?.permit === true && (
                                <ButtonOutlined
                                    onClick={handleToggleAddModal}
                                    startIcon={<img src={RouteImage.addButton} />}>
                                    <Typography className='text-primary'> {t("BUTTON.ADD")}</Typography>
                                </ButtonOutlined>
                            )}
                        </span>
                    </styled.TopicHeader>
                    <section className='mt-8 w-full h-auto'>
                        {types && (
                            <TableCustom
                                tableMinWidth={1000}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={types && types.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default ProjectTypeSetting